import Service from "../../../Services/index";

const FactorialMaterial = {
    namespaced: true,
    state: {
        factorialMaterialList: [],
        form:{
            id: null,
            name : "",
            source_id : "",
            quantity : 0,
        },
        search:{
            name: "",
            source_id : "",
        },
        dataPaginate: {
            current_page: 1,
            from: 1,
            last_page: 1,
            per_page: 1,
            total: 1,
            to: 1
        },
    },
    mutations: {
        GET_FACTORIAL_MATERIAL_BY_ID: (state, res) => {
            state.form = res;
        },
        CLEAR_FORM_DATA : (state)=>{
            state.form = {
                id: null,
                name : "",
                source_id : "",
                quantity : 0,
            }
        },
        CLEAR_SEARCH : (state) =>{
            state.search = {
                name: "",
                source_id : "",
            }
        }
    },
    actions: {
        setFactorialMaterial({ commit }, page = 1) {
            return Service.FactorialMaterial.getFactorialMaterial(page);
        },
        saveFactorialMaterial({commit},data){
            if(!data.id){
                return Service.FactorialMaterial.createFactorialMaterial(data).then(res=>{
                    console.log("create");
                });
            }
            else{
                return Service.FactorialMaterial.updateFactorialMaterial(data.id,data).then(res=>{
                    console.log("update");
                });
            }
        },
        showFactorialMaterialByID({commit},id){
            return Service.FactorialMaterial.showFactorialMaterial(id).then(res=>{
                commit("GET_FACTORIAL_MATERIAL_BY_ID",res);
            })
        },
        delete({ commit }, id) {
            return Service.FactorialMaterial.deleteFactorialMaterial(id)
                .catch(err => {
                    console.error(err);
                });
        },
        search({commit},data){
            return Service.FactorialMaterial.searchFactorialMaterial(data);
        },
        clearFormData({ commit }) {
            commit("CLEAR_FORM_DATA");
        },
        clearSearch({ commit }) {
            commit("CLEAR_SEARCH");
        },
    }
};

export default FactorialMaterial;
